var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_23852",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 169,
    height: 169
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_23852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.955 119.797C113.899 124.081 112.373 128.159 110.378 132.032C118.593 126.633 125.195 119.591 130.182 110.907C135.17 102.222 137.664 92.5397 137.664 81.8599C137.664 72.9404 135.845 64.6665 132.207 57.038C128.569 49.4095 123.698 42.8373 117.595 37.3213L133.791 21.1255H77.4579V77.4588L93.6537 61.263C100.695 66.4269 106.27 72.9111 110.378 80.7156C114.485 88.5201 116.539 97.1168 116.539 106.506C116.539 111.083 116.011 115.513 114.955 119.797Z",
    fill: "#9F1E3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2079 147.875L51.4037 131.68C45.1836 126.164 40.2837 119.591 36.7042 111.963C33.1247 104.335 31.335 96.0606 31.335 87.1411C31.335 76.4613 33.8289 66.779 38.8167 58.0942C43.8046 49.4095 50.4648 42.3678 58.7975 36.9692C56.8023 40.8422 55.2473 44.9205 54.1324 49.2041C53.0174 53.4878 52.46 57.9182 52.46 62.4953C52.46 71.8842 54.5431 80.4809 58.7094 88.2854C62.8758 96.0899 68.4211 102.574 75.3454 107.738L91.5412 91.5422V147.875H35.2079Z",
    fill: "#888988",
    fillOpacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncrease);
export default __webpack_public_path__ + "static/media/increase.9168e8e6e408955bc088c5ba1650a8e9.svg";
export { ForwardRef as ReactComponent };